import React from 'react'
import styled from 'styled-components'
import {getCurrencyValue} from 'utils'
import {useTranslation} from 'i18n'
import {PackageIcon, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {PaymentCheckoutPackageItemProps} from './PaymentCheckoutPackageProps'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: ${convertUnit(10)} 0;
  align-items: center;
`

const StyledDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: ${convertUnit(25)};
  margin-right: ${convertUnit(10)};
`

const StyledPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

const StyledSubInfo = styled(Paragraph)`
  margin-top: ${convertUnit(5)};
`

const StyledParagraph = styled(Paragraph)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  overflow-wrap: anywhere;
`

export default function PaymentCheckoutPackageItem({
  data: {price, creator_name, tree_name},
}: PaymentCheckoutPackageItemProps) {
  const {translate} = useTranslation()

  return (
    <StyledContainer>
      <PackageIcon />
      <StyledDescriptionContainer>
        <StyledParagraph fontSize="m" fontWeight="bold">
          {tree_name}
        </StyledParagraph>
        <StyledSubInfo>{creator_name}</StyledSubInfo>
      </StyledDescriptionContainer>
      <StyledPriceContainer>
        <Paragraph fontWeight="medium" color="gray_5">
          {translate('transaction:checkoutContentPrice')}
        </Paragraph>
        <StyledSubInfo fontSize="m" fontWeight="bold" color="primary_5">
          {getCurrencyValue(price)}
        </StyledSubInfo>
      </StyledPriceContainer>
    </StyledContainer>
  )
}
